'use client'

import React from 'react'
import { Clock, Infinity, AlertTriangle, CalendarDays } from 'lucide-react'
import { calculateOfferDuration } from '@/constants/hooks'

interface Props {
    endDate?: string | null
    className?: string
}

const ExpiryTag = ({ endDate, className = '' }: Props) => {
    const label = calculateOfferDuration(endDate ?? null)

    if (label === 'Offer expired') return (
        <span suppressHydrationWarning className={`inline-flex items-center gap-1 text-[9px] sm:text-[10px] font-bold px-2 py-0.5 rounded-md shadow-2xs ${className}`}
            style={{ background: 'rgba(220,38,38,0.1)', color: '#dc2626', border: '1px solid rgba(220,38,38,0.3)' }}>
            <AlertTriangle size={9} /> Expired
        </span>
    )

    if (label === 'Life Time') return (
        <span suppressHydrationWarning className={`inline-flex items-center gap-1 text-[9px] sm:text-[10px] font-bold px-2 py-0.5 rounded-md shadow-2xs ${className}`}
            style={{ background: '#E8F0E8', color: '#2D3E2D', border: '1px solid rgba(92,122,92,0.35)' }}>
            <Infinity size={9} /> Lifetime
        </span>
    )

    if (label === 'Last day') return (
        <span suppressHydrationWarning className={`inline-flex items-center gap-1 text-[9px] sm:text-[10px] font-black px-2 py-0.5 rounded-md shadow-2xs ${className}`}
            style={{ background: '#F5C542', color: '#2D3E2D', boxShadow: '0 1px 6px rgba(245,197,66,0.4)' }}>
            <Clock size={9} /> Last Day!
        </span>
    )

    const daysMatch = label.match(/^(\d+)\s+day/)
    const days = daysMatch ? parseInt(daysMatch[1]) : null
    const isUrgent = days !== null && days <= 3
    const isSoon = days !== null && days <= 7

    if (isUrgent) return (
        <span suppressHydrationWarning className={`inline-flex items-center gap-1 text-[9px] sm:text-[10px] font-bold px-2 py-0.5 rounded-md shadow-2xs ${className}`}
            style={{ background: 'rgba(245,197,66,0.2)', color: '#b45309', border: '1px solid rgba(245,197,66,0.5)' }}>
            <Clock size={9} /> {label}
        </span>
    )

    if (isSoon) return (
        <span suppressHydrationWarning className={`inline-flex items-center gap-1 text-[9px] sm:text-[10px] font-semibold px-2 py-0.5 rounded-md shadow-2xs ${className}`}
            style={{ background: '#E8F0E8', color: '#5C7A5C', border: '1px solid rgba(92,122,92,0.35)' }}>
            <CalendarDays size={9} /> {label}
        </span>
    )

    return (
        <span suppressHydrationWarning className={`inline-flex items-center gap-1 text-[9px] sm:text-[10px] font-semibold px-2 py-0.5 rounded-md shadow-2xs ${className}`}
            style={{ background: '#E8F0E8', color: '#5C7A5C', border: '1px solid rgba(92,122,92,0.25)' }}>
            <CalendarDays size={9} /> {label}
        </span>
    )
}

export default ExpiryTag
